<template>
  <a-modal v-model="visible" width="40%" @ok="handleOk" :footer="null">
    <div slot="title">{{ $t("forgotpwd.忘记密码") }}</div>
    <div>
      <div class="liginleft">
        {{ $t("forgotpwd.密码发邮件") }}
      </div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        style="flex: 1; margin-top: 10px"
      >
        <a-form-model-item
          style="color: #0067b3; font-size: 20px"
          label="EMAIL(电子邮箱)"
          prop="email"
        >
          <a-input
            v-model="form.email"
            placeholder="请填写您的邮箱"
            @blur="
              () => {
                $refs.email.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item>
          <div style="margin-left: 360px">
            <a-button
              icon="check"
              type="primary"
              @click="onSubmit"
              style="width: 100px"
            >
              {{ $t("forgotpwd.发送") }}
            </a-button>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      visible: false,
      data: [],
      form: {
        email: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "请填写你的电子邮箱，以便我们能给您发送密码重置邮件",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    //获取人员记录
    this.checkEmail();
  },
  methods: {
    checkEmail() {
      var _this = this;
      axios
        .post(this.$apiUrl + "/api/general/queryMulti", {
          tableName: "jf_web_user",
          offset: 0,
          limit: 10,
        })
        .then((res) => {
          _this.data = res.data.data;
        });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (
            this.data.filter((item) => item.email == this.form.email).length <=
            0
          ) {
            this.$notification.error({
              message: "您输入的邮箱没有注册",
            });
            return;
          }
          let arr = this.data.filter((item) => item.email == this.form.email);
          let password = arr[0].password;
          if (password != "") {
            axios
              .post(this.$apiUrl + "/api/web_email", {
                attachments: "",
                password: password,
                email: this.form.email,
              })
              .then((res) => {
                if (res.data.errCode == 0) {
                  this.$notification.success({
                    message: "操作成功,密码已经发至您的邮箱，请查收。",
                  });
                } else {
                  this.$notification.error({
                    message: "操作失败，请联系系统管理员",
                  });
                }
              });
          } else {
            this.$notification.error({
              message: "操作失败，请联系系统管理员",
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    show() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.liginleft {
  display: flex;
  justify-content: left;
  align-items: center;
  font-weight: 400;
  --bs-text-opacity: 1;
  font-size: 18px;
  color: #121111 !important;
}
.header {
  min-height: 85px;
  height: 85px;
  background: #0067b3;
  border: none;
}
</style>
